import { css } from '@/styled-system/css';

export const moduleContainer = css({
  paddingBottom: 'looser',
  scrollMarginTop: 'calc(var(--search-header-height, 0px) + {spacing.looser})',
  backgroundColor: 'bg.neutral',
  borderBottomWidth: 'default',
  borderBottomStyle: 'solid',
  borderBottomColor: 'border.neutral',
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  overflow: 'hidden',
  '&:has(> [data-module-content]:empty)': {
    display: 'none',
  },
  '&#inline-contact-module': {
    display: 'none',
    lg: {
      display: 'flex',
    },
  },
});

export const listingSummaryOverflow = css({
  overflow: 'visible',
});

export const moduleTopPadding = css({
  paddingTop: 'looser',
});

export const moduleHeaderRow = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'default',
});

export const moduleTitle = css({
  fontSize: 'heading-xs', // 20px font size
  lineHeight: 'heading-xs', // 24px line height
  color: 'text.neutral', // Title color as specified
  fontWeight: 'bold',
  margin: '0', // Reset default heading margins
  padding: '0', // Reset default heading padding
});

export const moduleContent = css({
  display: 'flex',
  flexDirection: 'column',
  flex: '1', // Take up available space between title and footer
});

export const moduleFooter = css({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 'auto', // Push footer to bottom if needed
});
